<template>
    <div class="vx-card px-6 py-2">
        <div class="vx-row">
            <div class="vx-col lg:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label">Chi nhánh</label>
                <v-select class="w-full" v-model="selectedBranch" :options="branchOptions" :clearable="false">
                    <span slot="no-options">{{ this.$t('menuOrganization.noOption') }}</span>
                </v-select>
            </div>

            <div class="vx-col lg:w-1/3 sm:w-1/2 w-full sm:mt-0 mt-2">
                <label class="vs-input--label">Thời gian</label>
                <date-range-picker class="w-full" ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }" :opens="'right'"
                                   @update="dateRangePicker" v-model="dateRange">
                </date-range-picker>
            </div>

            <div class="vx-col lg:w-1/3 sm:w-1/2 w-full lg:mt-0 mt-2">
                <label class="vs-input--label">Loại</label>
                <v-select class="w-full" v-model="selectedType" :options="typeOptions" :clearable="false"></v-select>
            </div>

            <div class="vx-col lg:w-1/3 sm:w-1/2 w-full lg:mt-4 mt-2">
                <label class="vs-input--label">Trạng thái</label>
                <v-select class="w-full" v-model="selectedstatus" :options="statusOptions"
                          :clearable="false"></v-select>
            </div>

            <div class="vx-col lg:w-1/3 sm:w-1/2 w-full lg:mt-4 mt-2">
                <label class="vs-input--label">Tìm kiếm</label>
                <vs-input class="w-full" v-model="keySearch" :placeholder="$t('menuNewsEvent.searchTitle')"
                          v-on:keyup.enter="filter"/>
            </div>

            <div class="vx-col lg:w-1/4 w-1/2 lg:mt-4 sm:mt-2 mt-4">
                <vs-button class="sm:mt-6" color="primary" iconPack="feather" @click="getAllNews"
                           icon="icon-search">
                    {{ this.$t('menuNewsEvent.search') }}
                </vs-button>
            </div>

            <div class="vx-col lg:w-1/2 w-1/2">
                <vs-button class="sm:mt-6 mt-4 sm:float-left float-right" color="primary" iconPack="feather"
                           icon="icon-plus" @click="$router.push('/user/info-news-event')"
                           v-if="isPermissionCreateNewsEvent">
                    {{ this.$t('menuNewsEvent.addNewsEvent') }}
                </vs-button>
            </div>
        </div>
        <!--End Items-->

        <!--Table & Pagination-->
        <div class="vs-row mt-6">
            <!--Table-->
            <ag-grid-vue style="height: 55vh" ref="agGridTable" :gridOptions="gridOptions"
                         class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="serviceTypeData" :animateRows="true" :pagination="true"
                         :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }" :onGridReady="onGridReady"
                         :suppressPaginationPanel="true">
            </ag-grid-vue>
            <!--Pagination-->
            <div class="vx-row" v-if="serviceTypeData.length > 0">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                        <span class="vx-col mt-2">Số phần tử / trang:</span>
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        serviceTypeData.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : serviceTypeData.length
                                    }} /
                                    {{ totalElements }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item @click="changePageSize(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(30)">
                                    <span>30</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(50)">
                                    <span>50</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(100)">
                                    <span>100</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage"/>
                </div>
            </div>
        </div>
        <!-- End Table & Pagination-->
    </div>
</template>
<script>
import DateRangePicker from '../../../../components/vue2-daterange-picker/components/DateRangePicker.vue'
import vSelect from 'vue-select';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererActions from "./cell-renderer/CellRendererActions";
import CellRendererStatus from "./cell-renderer/CellRendererStatus";
import moment from 'moment';
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";

export default {
    components: {
        vSelect,
        AgGridVue,
        CellRendererActions,
        DateRangePicker,
        CellRendererStatus,
    },
    data() {
        return {
            dateRange: {
                endDate: new Date(),
                startDate: new Date(new Date().setMonth(new Date().getMonth() - 3)).setUTCHours(0, 0, 0, 0),
            },
            columnDefs: [
                {
                    headerName: this.$t('menuNewsEvent.stt'),
                    field: 'stt',
                    width: 70
                },
                {
                    headerName: this.$t('menuNewsEvent.nameTitle'),
                    field: 'title',
                    width: 250
                },
                {
                    headerName: this.$t('menuNewsEvent.createdDate'),
                    field: 'createdDate',
                    width: 120
                },
                {
                    headerName: this.$t('menuNewsEvent.type'),
                    field: 'type',
                    width: 120,
                    cellRendererFramework: 'CellRendererStatus',
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 120,
                    cellRendererFramework: 'CellRendererActions',
                },
            ],
            branchOptions: [],
            serviceTypeData: [],
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            pageNumber: 0,
            pageSize: 20,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            selectedBranchValue: null,
            keySearch: null,
            statusOptions: [
                {value: null, label: 'Tất cả'},
                {value: 0, label: 'Tắt'},
                {value: 1, label: 'Bật'},
            ],
            typeOptions: [
                {value: null, label: 'Tất cả'},
                {value: 1, label: 'Tin tức'},
                {value: 2, label: 'Sự kiện'},
                {value: 3, label: 'Tài liệu thẩm mỹ'},
                {value: 4, label: 'Khuyến mãi'},
            ],
            selectedTypeValue: null,
            selectedstatusValue: null,
        }
    },

    created() {

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        this.branchOptions.unshift({value: null, label: 'Tất cả'});
        this.getAllNews();
    },
    computed: {
        selectedBranch: {
            get() {
                let obj = this.branchOptions.find(x => x.value === this.selectedBranchValue);
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
            }
        },
        selectedType: {
            get() {
                let obj = this.typeOptions.find(x => x.value === this.selectedTypeValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedTypeValue = obj ? obj.value : null;
            }
        },
        selectedstatus: {
            get() {
                let obj = this.statusOptions.find(x => x.value === this.selectedstatusValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedstatusValue = obj ? obj.value : null;
            }
        },
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateNewsEvent'(val) {
            if (val) {
                this.getAllNews();
                this.$store.commit('UPDATE_NEWS_EVENT', false);
            }
        }
    },
    methods: {
        getAllNews() {
            let payload = {
                organizationBranchId: this.selectedBranchValue,
                keySearch: this.keySearch,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                startDate: this.dateRange.startDate,
                endDate: this.dateRange.endDate,
                activeStatus: this.selectedstatusValue,
                type: this.selectedTypeValue,
            }
            this.$vs.loading();
            this.$crm.post('/beauty-post/find-by-condition', payload).then(res => {
                this.serviceTypeData = res.data.content.map(el => {
                    el.stt = this.pageSize * this.pageNumber + res.data.content.indexOf(el) + 1;
                    el.createdDate = moment(el.createdDate).format('DD/MM/YYYY HH:mm')
                    return el;
                })
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val)
        },
        addNewsEvent() {
            this.$router.push('/user/info-news-event')
        },
        onGridReady() {
            if (this.$store.state.windowWidth <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        //timeKeeping
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
        },
        //Pagination
        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getAllNews();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getAllNews();
        },

        filter() {
            this.currentPage = 1;
            this.pageNumber = 0;
            this.getAllNews();
        },

        isPermissionCreateNewsEvent() {
            return isAPI(this, constAPI.beauty_post_create);
        },
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    }
}
</script>
